export const img500x500 = "https://image.tmdb.org/t/p/w500";
